// extracted by mini-css-extract-plugin
module.exports = {"root":"ShortStats_root___5XTl","item":"ShortStats_item__yWCcy"};